module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message.user == this.$root.user.uid) ? _c('div', {
    staticClass: "message mine"
  }, [(!_vm.continuedMessage) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'h:MMtt')))]) : _vm._e(), _vm._v(" "), (!_vm.continuedMessage) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'ddd dS mmm')) + ",")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "bubble"
  }, [_vm._v(_vm._s(_vm.message.content))]), _vm._v(" "), (!_vm.finalMessage) ? _c('div', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.from.firstname + ' ' + _vm.from.surname))]), _vm._v(" "), _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.from.profileimg
    }
  })]) : _vm._e()]) : _c('div', {
    staticClass: "message"
  }, [(!_vm.continuedMessage) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'ddd dS mmm')) + ",")]) : _vm._e(), _vm._v(" "), (!_vm.continuedMessage) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'h:MMtt')))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "bubble"
  }, [_vm._v(_vm._s(_vm.message.content))]), _vm._v(" "), (!_vm.finalMessage) ? _c('div', {
    staticClass: "author"
  }, [_c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.from.profileimg
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.from.firstname + ' ' + _vm.from.surname))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46fe9ce5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Message.vue
// module id = 708
// module chunks = 1